/* Package JSON Import will be here */
import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

const AddToHomeScreen = (props) => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale),
    }));

    useEffect(() => {
        const handler = e => {
            e.preventDefault();
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    const openPwaPopup = evt => {
        evt.preventDefault();

        /* close the menu dropdown */
        props.toggleAccount();

        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };

    /* Return null if the PWA option not supported */
    if (!supportsPWA) {
        if (props.addToHomeError !== undefined) {
            props.addToHomeError();
        }
        return null;
    }
    else {
        if (props.addToHomeSuccess !== undefined) {
            props.addToHomeSuccess();
        }
    }

    /* Check for client app name based on the customer */
    let clientAppName = translate("common.ivyMarketplace");
    if (window.clientAppName.trim() !== "")
        clientAppName = window.clientAppName;

    /* Else return thr input element to activate the add to home screen */
    return (
        <React.Fragment>
            {props.pageType === "HeaderMenu" ?
                (<span className="cursor-pointer" onClick={openPwaPopup}> {translate("common.buttons.addToHomeScreen")}</span>)
                :
                (<Modal
                    visible={props.isShowAddToHomeScreen}
                    centered
                    title={translate("common.addToHomeScreen.title", { appName: clientAppName })}
                    closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                    onOk={openPwaPopup}
                    onCancel={props.toggleAccount}
                    footer={[
                        <Button key="cancel" onClick={props.toggleAccount}>
                            {translate("common.buttons.cancel")}
                        </Button>,
                        <Button
                            key="ok"
                            onClick={openPwaPopup}
                            type="primary">
                            {translate("common.buttons.addToHomeScreen")}
                        </Button>
                    ]}
                >
                    <p>{translate("common.addToHomeScreen.description", { appName: clientAppName })}</p>
                </Modal>)
            }
        </React.Fragment>
    );
};

export default AddToHomeScreen;